import { db, projectStorage } from "@/firebase/config";
import { getStringAfterDash, getStringBeforeDash } from "@/scripts/utils";
import { arrayUnion, doc, setDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";

export const uploadUserImage = async (file, uid = null) => {
    return new Promise(async (resolve, reject) => {
        const userId = uid
        // Create the file metadata
        /** @type {any} */
        const metadata = {
            contentType: file.type
        };

        // Upload file and metadata to the object 'images/mountains.jpg'
        const storageRef = userId ? ref(projectStorage, `images/${userId}/image`) : ref(projectStorage, `images/background/image`);
        const uploadTask = uploadBytesResumable(storageRef, file, metadata);

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on('state_changed',
            (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                    case 'paused':
                        console.log('Upload is paused');
                        break;
                    case 'running':
                        console.log('Upload is running');
                        break;
                }
            },
            (error) => {
                console.log("error: ", error)
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    // ...

                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                }
                reject(error);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref)
                    .then(async (downloadURL) => {
                        if (userId) {
                            const docRef = userId.includes('-')
                                ? doc(db, `users/${getStringBeforeDash(userId)}/family`, getStringAfterDash(userId))
                                : doc(db, `users`, userId);

                            const reqDocRef = doc(db, 'picAuthReqs', 'authReqs')

                            try {
                                await setDoc(docRef, { pic_auth: 'approved', pic_up_date: new Date() }, { merge: true });
                                // Disabled picture approval queue: await setDoc(reqDocRef, { userIds: arrayUnion(userId) }, { merge: true });
                                console.log("Document successfully updated!");
                                resolve(downloadURL);
                            } catch (error) {
                                console.error("Error updating document: ", error);
                                reject(error);
                            }
                        } else {
                            resolve(downloadURL);
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            }
        );
    });
};

export const deleteUserImage = async (uid = null) => {
    return new Promise(async (resolve, reject) => {
        try {
            const userId = uid;
            const fileName = 'image';

            const fileRef = userId
                ? ref(projectStorage, `images/${userId}/${fileName}`)
                : ref(projectStorage, `images/background/${fileName}`);

            // Delete the file
            await deleteObject(fileRef);

            console.log('File deleted successfully');
            resolve('File deleted successfully');
        } catch (error) {
            console.error('Error deleting file:', error);
            reject(error);
        }
    });
};